import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import {
  ButtonAuthorizedWrapper,
  DivAuthorizedWrapper,
  RentReportingInfoCard,
  TermsText,
  Wrapper,
} from "src/components";
import { ContentContainer, PageHeader } from "src/components/Layouts/AppShell";

export const RentReportingInfoScreenContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Wrapper isAuthorizedWrapper idSelector={"wrapperContainer"}>
        <ContentContainer size="narrow">
          <PageHeader title={t("rentReporting.header")} />
          <DivAuthorizedWrapper className="note_notify">
            <RentReportingInfoCard />
            <ButtonAuthorizedWrapper>
              <TermsText
                mainContent={t(
                  "rentReporting.reportingInfo.informationContent"
                )}
                subContent={t(
                  "rentReporting.reportingInfo.informationSubContent"
                )}
                marginIndex="0 0 16px"
              />
              <Button
                variant="containedLarge"
                color="primary"
                fullWidth
                type="button"
                sx={{ overflow: "hidden" }}
                onClick={() => navigate("/rent/reporting/identity")}
              >
                {t("buttonTexts.continueButton")}
              </Button>
            </ButtonAuthorizedWrapper>
          </DivAuthorizedWrapper>
        </ContentContainer>
      </Wrapper>
    </>
  );
};
